/**
 * Static book catalog for the knowledge-graph. Keeps `keywords` deliberately
 * broad so string overlap with post categories/titles finds sensible matches.
 * Covers are intentionally omitted here — the graph card only needs metadata.
 */
export type KGBook = {
  slug: string;
  href: string;
  title: string;
  subtitle: string;
  year: string;
  publisher: string;
  summary: string;
  keywords: string[];
};

export const KG_BOOKS: KGBook[] = [
  {
    slug: "hayati-yasanir-kilan-bosluktur",
    href: "/kitaplar/hayati-yasanir-kilan-bosluktur",
    title: "Hayatı Yaşanır Kılan, Boşluktur",
    subtitle: "İnsanın, yaşamın ve anlamın son sığınağı.",
    year: "2026",
    publisher: "Destek Yayınları",
    summary:
      "Verimlilik, ölçü ve optimizasyon çağında insan kalmanın ve ölçülemeyeni korumanın bedelini sorgulayan kitap.",
    keywords: [
      "verimlilik",
      "ölçü",
      "optimizasyon",
      "insan",
      "anlam",
      "muhakeme",
      "güven",
      "iklim",
      "yapay zekâ",
      "yalnızlık",
      "efficiency",
      "human judgment",
    ],
  },
  {
    slug: "yalnizlik-as",
    href: "/kitaplar/yalnizlik-as",
    title: "Yalnızlık A.Ş.",
    subtitle: "Yalnızlık nasıl en kârlı sektör oldu?",
    year: "2026",
    publisher: "Ücretsiz PDF — Üyelere Özel",
    summary:
      "Yalnızlığın nasıl bir ekonomiye dönüştüğünü, dijital bağların yerini tuttuğu bir çağda insanı ve toplumu inceleyen kitap.",
    keywords: [
      "yalnızlık",
      "loneliness",
      "dikkat",
      "sosyal medya",
      "toplum",
      "insan",
      "human",
      "society",
      "attention",
      "yalnızlık ekonomisi",
      "loneliness economy",
    ],
  },
  {
    slug: "yapay-zeka-gucun-iki-yuzu",
    href: "/kitaplar/yapay-zeka-gucun-iki-yuzu",
    title: "Yapay Zekâ: Gücün İki Yüzü",
    subtitle: "Yapay zekânın umut ve risk ekseninde saha rehberi.",
    year: "2024",
    publisher: "Destek Yayınları",
    summary:
      "Yapay zekânın gündelik hayata, iş dünyasına ve topluma etkilerini sade bir dille ele alan; bireylerin ve kurumların hazırlığı için pratik bir çerçeve sunan kitap.",
    keywords: [
      "yapay zeka",
      "yapay zekâ",
      "ai",
      "artificial intelligence",
      "algoritma",
      "algorithm",
      "veri",
      "data",
      "teknoloji",
      "technology",
      "muhakeme",
      "epistemik",
      "algoritmik teslimiyet",
      "algorithmic surrender",
      "epistemik silahlanma",
      "epistemic weaponisation",
    ],
  },
  {
    slug: "iklim-degil-insanlik-krizi",
    href: "/kitaplar/iklim-degil-insanlik-krizi",
    title: "İklim Değil, İnsanlık Krizi",
    subtitle: "Sürdürülebilirliği insan ekseninde okuyan bir çağrı.",
    year: "2023",
    publisher: "Yeni İnsan Yayınevi",
    summary:
      "İklim krizinin aslında bir insanlık meselesi olduğunu; çözümün bireysel sorumluluk ve küçük adımlarda saklı olduğunu anlatan kitap.",
    keywords: [
      "iklim",
      "climate",
      "sürdürülebilirlik",
      "sustainability",
      "ekoloji",
      "ecology",
      "çevre",
      "environment",
      "insan",
      "human",
      "gezegen",
      "planet",
      "ekonomi",
      "economy",
      "karbon",
      "carbon",
      "jevons",
      "rebound",
      "ayrışma tezi",
      "decoupling",
      "washing",
    ],
  },
];
